export enum FinancialReportType {
  Standard,
  Monthly,
  Tag,
}

export enum AccountingCategoryType {
  Revenue = 0,
  Sales = 1,
  CapitalizedWork = 2,
  OtherIncome = 3,
  DirectCosts = 4,
  PurchaseOfGoodsAndMaterials = 5,
  Subcontractors = 6,
  WorkInProgressAndChangeInInventory = 7,
  SumContributionMarginAfterDirectCosts = 8,
  Staff = 9,
  Wages = 10,
  Expenses = 11,
  PensionCosts = 12,
  SocialExpenses = 13,
  OtherStaffCosts = 14,
  SumContributionMarginForStaffCosts = 15,
  Overhead = 16,
  LocalCosts = 17,
  BuildingCosts = 18,
  RentalOfFixedAssets = 19,
  EnergyCosts = 20,
  Consumption = 21,
  RepairAndMaintenance = 22,
  Transportation = 23,
  Shipping = 24,
  TravelExpenses = 25,
  AdvertisingAndPr = 26,
  OtherSellingExpenses = 27,
  OfficeSupplies = 28,
  TelecommunicationsAndPost = 29,
  BusinessInsurance = 30,
  ManagementCosts = 31,
  OtherServices = 32,
  OtherExpenses = 33,
  OtherOperatingExpenses = 34,
  SumEarningsBeforeDepriciation = 35,
  Impairments = 36,
  Depreciation = 37,
  SumOperatingIncome = 38,
  FinancialItems = 39,
  InterestIncome = 40,
  InterestExpense = 41,
  OtherFinancialItems = 42,
  ExtraordinaryItems = 43,
  Allocations = 44,
  SumProfitAfterFinancialItems = 45,
  Taxes = 46,
  Results = 47,
  RecordsOfInvestigation = 48,
  FixedAssets = 49,
  IntangibleAssets = 50,
  LandAndBuildings = 51,
  MachineryAndEquipment = 52,
  FinancialAssets = 53,
  CurrentAssets = 54,
  InventoryAndWorkInProgress = 55,
  AccountsReceivable = 56,
  OtherCurrentAssets = 57,
  PrepaymentsAccruedIncome = 58,
  CurrentInvestments = 59,
  CashAndBankBalances = 60,
  SumTotalAssets = 61,
  Equity = 62,
  UntaxedReserves = 63,
  Provisions = 64,
  LongTermLiabilities = 65,
  TheOverdraftFacility = 66,
  LongTermLiabilitiesToBanks = 67,
  OtherLongTermLiabilities = 68,
  CurrentLiabilities = 69,
  AccountsPayable = 70,
  TaxLiabilities = 71,
  VATAndExciseDuties = 72,
  PersonnelTaxes = 73,
  CurrentLiabilitiesToBanks = 74,
  AdvancesFromCustomersWorkInProgress = 75,
  OtherCurrentLiabilities = 76,
  AccruedExpensesDeferredIncome = 77,
  SumEquityAndLiabilities = 78,
  SumNotBookedResultsInBalanceReport = 79,
  SumResults = 80,
  SumNotBookedResultsInResultReport = 81,
}
